import React from 'react'

function RadioContainer({
  options,
  title,
  info,
  onRadioChange,
  formKey,
  value,
}) {
  return (
    <div role="radiogroup">
      <h3 className="wb-margin-bottom-xxs wb-type-copy">{title}</h3>
      {options.map((o) => (
        <wb-radio-control class="wb-margin-bottom-xxs" key={o.key}>
          <label>
            <input
              type="radio"
              name={formKey}
              value={o.key}
              checked={o.key === value}
              onChange={(event) => {
                onRadioChange(event.target.value)
              }}
            />
            {o.label}
          </label>
        </wb-radio-control>
      ))}
      {info && info.length && (
        <wb-control-hint className="wb-padding-start-xs">
          {info}
        </wb-control-hint>
      )}
    </div>
  )
}

export default RadioContainer
